const defaults = {
  moduleSelector: '[data-list-with-image]',
};

function isTouchDevice() {
  return (('ontouchstart' in window)
    || (navigator.maxTouchPoints > 0)
    || (navigator.msMaxTouchPoints > 0));
}
export default class ListWithImage {
  constructor(settings = {}) {
    this.settings = { ...defaults, ...settings };
    this.current = 0;
  }

  init() {
    const $modules = [...document.querySelectorAll(this.settings.moduleSelector)];

    if ($modules.length === 0) {
      return this;
    }

    $modules.forEach(($module) => {
      this.initModule($module);
    });

    return this;
  }

  initModule($module) {
    const $triggers = [...$module.querySelectorAll('[data-list-with-image-trigger]')];

    if (isTouchDevice()) {
      setInterval(() => {
        this.randomShowImage($module);
      }, 3000);
    } else {
      $triggers.forEach(($trigger) => {
        $trigger.addEventListener('mouseenter', () => {
          this.showImage($module, $trigger.dataset.listWithImageTrigger);
        });
      });
    }

    return this;
  }

  showImage($module, id) {
    const $imageToShow = $module.querySelector(`[data-list-with-image-id="${id}"]`);

    this.hideAllImages($module);

    $imageToShow.style.opacity = '1';

    return this;
  }

  hideAllImages($module) {
    const $images = [...$module.querySelectorAll('[data-list-with-image-id]')];

    $images.forEach(($image) => {
      const image = $image;
      image.style.opacity = '0';
    });

    return this;
  }

  randomShowImage($module) {
    const $images = [...$module.querySelectorAll('[data-list-with-image-id]')];
    this.hideAllImages($module);

    this.current += 1;

    if (this.current >= $images.length) {
      this.current = 0;
    }

    $images[this.current].style.opacity = '1';

    return this;
  }
}
